export default "/assets/814e7fb3ea32fb1d.png"